export default __webpack_public_path__ + "static/media/28.43e3ddce.png";